import {
    UserModel,
    AuthServiceLoginBody,
    AuthServiceLoginResult,
    AuthServiceTwoFaSetupResult,
    AuthServiceTwoFaVerifyBody,
} from '@/types';
import BaseService from '@/services/api/BaseService';

class AuthService extends BaseService<UserModel> {
    constructor() {
        super('');
    }

    async login(loginBody: AuthServiceLoginBody) {
        return this.http.post<AuthServiceLoginResult>('auth/login', loginBody);
    }

    async twoFaSetup() {
        return this.http.post<AuthServiceTwoFaSetupResult>(
            'auth/2fa/setup',
            {},
            {
                headers: {
                    authorization: 'Bearer ' + localStorage.getItem('tokenTemp'),
                },
            },
        );
    }

    async twoFaVerifySetup(body: AuthServiceTwoFaVerifyBody) {
        return this.http.post<AuthServiceLoginResult>('auth/2fa/verify-setup', body, {
            headers: {
                authorization: 'Bearer ' + localStorage.getItem('tokenTemp'),
            },
        });
    }

    async twoFaVerify(body: AuthServiceTwoFaVerifyBody) {
        return this.http.post<AuthServiceLoginResult>('auth/2fa/verify', body, {
            headers: {
                authorization: 'Bearer ' + localStorage.getItem('tokenTemp'),
            },
        });
    }

    async check() {
        return this.http.get<AuthServiceLoginResult>('auth/check');
    }
}

export default new AuthService();
